import * as Yup from 'yup';
import {FIELD_ERRORS} from '../../../constants';

export interface ISubstrateOptionForm {
    title: string;
}

export const initial: ISubstrateOptionForm = {title: ''};

export const validationSchema = Yup.object({
    title: Yup.string().required(FIELD_ERRORS.REQUIRED),
});
